// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2361":"132755083eca0819","4420":"33c54bd7bbd63d61","4807":"3de02a527d582311","5405":"f8f97fc05f81a8c1","6337":"34cca8c9ebe3665f"}[chunkId] + ".css";
};